import { render, staticRenderFns } from "./SalesOverview.vue?vue&type=template&id=0f80787a"
import script from "./SalesOverview.vue?vue&type=script&lang=ts"
export * from "./SalesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports